import * as React from 'react';
//@ts-ignore
import { Primary, Secondary } from '@churchofjesuschrist/eden-buttons';
//@ts-ignore
import { Info, Modal } from '@churchofjesuschrist/eden-alert';
import { cancelOrderAsync } from '../../../actions/DataActionExtension.g';

//@ts-ignore
import { ProgressSection } from '@churchofjesuschrist/eden-progress';

// import { format } from '@msdyn365-commerce-modules/utilities';

export interface ICancelOrderModalProps {
    isOpen: boolean;
    isLoading: boolean;
    onClose: () => void;
    onConfirm: () => void;
    resource: any;
    allowOrderSyncCancelation?: boolean | undefined;
    isOrderCancelled?: boolean | null | undefined;
    orderId?: string;
    salesOrderId?: string;
}

/**
 * Shared cancel-order confirmation modal.
 *
 * Usage example (do not wire up until reviewed):
 *
 *   const { isOpen, isLoading, openCancelOrder, closeCancelOrder, confirmCancelOrder } =
 *       useCancelOrder(context.actionContext);
 *
 *   <Ghost onClick={() => openCancelOrder(channelReferenceId)}>Cancel Order</Ghost>
 *   <CancelOrderModal
 *       isOpen={isOpen}
 *       isLoading={isLoading}
 *       onClose={closeCancelOrder}
 *       onConfirm={confirmCancelOrder}
 *   />
 */
export const CancelOrderModal: React.FC<ICancelOrderModalProps> = ({
    isOpen,
    isLoading,
    onClose,
    onConfirm,
    resource,
    isOrderCancelled,
    orderId,
    salesOrderId,
    allowOrderSyncCancelation
}) => {
    const allowOrderCancelation = allowOrderSyncCancelation === true || salesOrderId?.includes('SO-');
    return (
        <Modal open={isOpen}>
            <Info onClose={onClose} style={{ width: '400px', margin: '0 auto' }}>
                <div>
                    <h2 style={{ paddingTop: '3px', marginBottom: '10px' }}>{resource.cancelOrderLabel}</h2>
                    {!isLoading && isOrderCancelled === null && allowOrderCancelation === true && <p>{resource.cancelOrderDescription}</p>}
                    {isLoading && allowOrderCancelation === true && <p>{resource.cancelOrderTimeout}</p>}
                    {!isLoading && allowOrderCancelation === false && <p>{resource.cancelOrderSyncDisabledDescription}</p>}
                    {/* {isLoading && <ProgressSection />} */}
                    {/* {isOrderCancelled === true && !isLoading && <p>{format(resource.cancelOrderSuccess, salesOrderId, orderId)}</p>} */}
                    {/* {isOrderCancelled === true && !isLoading && salesOrderId && !salesOrderId.includes('SO-') && (
                        <p>{format(resource.cancelOrderSuccessNoSalesOrderId, orderId)}</p>
                    )} */}
                    {/* {isOrderCancelled === false && !isLoading && salesOrderId && salesOrderId.includes('SO-') && (
                        <p>{format(resource.cancelOrderFailed, salesOrderId, orderId)}</p>
                    )}
                    {isOrderCancelled === false && !isLoading && salesOrderId && !salesOrderId.includes('SO-') && (
                        <p>{format(resource.cancelOrderFailedNoSalesOrderId, orderId)}</p>
                    )} */}
                    {/* {isOrderCancelled === false && !isLoading && !salesOrderId && <p>{format(resource.cancelOrderFailedNoSalesOrderId, orderId)}</p>} */}
                    {/* {isOrderCancelled === false && !isLoading && <p>{resource.cancelOrderFailed}</p>} */}
                </div>
                {isLoading ||
                    (allowOrderCancelation === false && (
                        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '10px' }}>
                            <Primary onClick={onClose} style={{ width: '100%', marginRight: '10px' }}>
                                {resource.closeNotificationLabel}
                            </Primary>
                        </div>
                    ))}
                {!isLoading && isOrderCancelled === null && allowOrderCancelation === true && (
                    <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '10px' }}>
                        <Primary onClick={onConfirm} style={{ width: '100%', marginRight: '10px' }}>
                            {resource.cancelOrderConfirmation}
                        </Primary>
                        <Secondary onClick={onClose} style={{ width: '100%' }}>
                            {resource.cancelOrderCancellation}
                        </Secondary>
                    </div>
                )}
            </Info>
        </Modal>
    );
};

export interface IUseCancelOrderResult {
    isOpen: boolean;
    isLoading: boolean;
    orderId: string;
    openCancelOrder: (orderId: string) => void;
    closeCancelOrder: () => void;
    confirmCancelOrder: () => Promise<void>;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setOrderId: React.Dispatch<React.SetStateAction<string>>;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * Optional hook that owns modal open/loading state and the cancelOrderAsync call.
 * Pass actionContext from the module/view (e.g. props.context.actionContext).
 */
export const useCancelOrder = (actionContext: any): IUseCancelOrderResult => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [orderId, setOrderId] = React.useState('');

    const openCancelOrder = (id: string) => {
        setOrderId(id);
        setIsOpen(true);
    };

    const closeCancelOrder = () => {
        setIsOpen(false);
    };

    const confirmCancelOrder = async () => {
        const ctx = { callerContext: actionContext };
        // let res: any;
        setIsLoading(true);
        if (orderId) {
            // res = await cancelOrderAsync(ctx, orderId);
            await cancelOrderAsync(ctx, orderId);
        }
        // console.log('res', res);
        setIsLoading(false);
    };

    return {
        isOpen,
        isLoading,
        orderId,
        openCancelOrder,
        closeCancelOrder,
        confirmCancelOrder,
        setIsOpen,
        setOrderId,
        setIsLoading
    };
};

export default CancelOrderModal;
